<template>
  <div class="rfp-rr-title-section-174-or rr-title-section" :class="{ 'rfp-rr-rating-rtl': rtl }">
    <h2
      id="rfp-rr-title"
      class="rfp-rr-title-section-175-or float-left"
      :class="{ 'rfp-rr-rating-rtl-float-right': rtl }"
      v-text="title"
    ></h2>

    <button
      v-if="enabled"
      aria-haspopup="dialog"
      class="rfp-rr-title-section-176-or rfp-rr-button write-review-btn float-right"
      :class="{ 'rfp-rr-rating-rtl-float-left': rtl }"
      @click="writeReviewButtonClickHandler"
      v-text="buttonText"
    ></button>
  </div>
</template>

<script>
import { handleWriteReviewButtonClick } from '../../../lib/widget/handleWriteReviewButtonClick';

export default {
  name: 'rfp-ratings-title-section',
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    productItemId: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    rtl: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    writeReviewButtonClickHandler() {
      handleWriteReviewButtonClick({
        $cookies: this.$cookies,
        buttonText: this.buttonText,
        productItemId: this.productItemId,
      });
    },
  },
};
</script>
